import { cn } from '@/utils/utils.ts';
import Logo from '@tenant/logo';
import { TNotification } from '@/features/notifications/schemas/notifications.schemas.ts';
import { formatDistance } from 'date-fns';
import { Link } from 'react-router';
import { NotificationCardPopover } from '@/features/notifications/components/notification-card-popover.tsx';
import { useNotificationsStore } from '@/services/store/use-notifications-store.ts';

export const NotificationCard = ({ notification }: { notification: TNotification }) => {
  const { title, description, createdAt, status, actionUrl } = notification;
  const setIsPopoverOpen = useNotificationsStore((state) => state.setIsPopoverOpen);

  const notificationDate = new Date(createdAt ?? '');
  const formattedDate = formatDistance(notificationDate, new Date(), {
    addSuffix: true,
  });

  return (
    <li
      className={cn(
        `group hover:bg-primary/5 relative flex w-full ease-in-out`,
        status === 'unread' && 'bg-blue-50/30'
      )}
    >
      {actionUrl && (
        <Link
          to={actionUrl}
          aria-label={title || 'Notification'}
          className="absolute inset-0 z-0"
          onClick={() => setIsPopoverOpen(false)}
        />
      )}
      {status === 'unread' && (
        <span
          className={cn('bg-primary absolute top-4.5 right-7 size-2 min-w-2 rounded-full')}
        ></span>
      )}
      <div className="w-full">
        <div className="flex w-full p-4 py-3">
          <div className="flex-shrink-0">
            <div className="ring-primary/30 flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br ring-1">
              <Logo width="24px" height="24px" withText={false} />
            </div>
          </div>

          <div className="ml-4 min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <h3 className="line-clamp-2 text-sm leading-5 font-semibold overflow-ellipsis text-gray-900">
                {title || 'Notification'}
              </h3>
            </div>

            {description && (
              <div>
                <p className="line-clamp-3 text-sm leading-relaxed text-gray-600">
                  {description}
                </p>
              </div>
            )}

            <time
              className="text-xs font-medium text-gray-500"
              dateTime={createdAt}
              title={notificationDate.toLocaleString()}
            >
              {formattedDate}
            </time>
          </div>
          <div className="relative z-10 flex items-center">
            <NotificationCardPopover notification={notification} />
          </div>
        </div>
      </div>
    </li>
  );
};
